var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy336(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80 C4,6.5,6.5,4,9.6,4H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80 C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lamps"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_27_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 39.1,
    cy: 24.1,
    rx: 4.8,
    ry: 4.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_26_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 59,
    cy: 24.1,
    rx: 4.8,
    ry: 4.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_25_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 49.1,
    cy: 45.2,
    rx: 4.8,
    ry: 4.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_24_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 63.1,
    cy: 39.4,
    rx: 2.6,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_23_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 35,
    cy: 39.3,
    rx: 2.6,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 49.1,
    cy: 32.9,
    r: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_22_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 35.7,
    cy: 75.6,
    rx: 8.8,
    ry: 8.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_2_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 62.4,
    cy: 75.6,
    rx: 8.8,
    ry: 8.8
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M63.5,90.3H34.6c-8,0-14.6-6.5-14.6-14.6v0c0-8,6.5-14.6,14.6-14.6h28.9c8,0,14.6,6.5,14.6,14.6v0C78.1,83.8,71.6,90.3,63.5,90.3z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy336);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-336.149d072eddb4238f825ebe3aefa794ff.svg";
export { ForwardRef as ReactComponent };